import {
  BlockoutRepeatTypes,
  PaymentTypes,
  BookingStatus,
  ViewTypes,
  BookingType,
  StandbyCommunicationTypes
} from "app/app.types";
import {
  appURLS,
  hardCodedTags,
  DocumentTypes,
  Providers,
  AppCache,
  Database,
  Dimensions,
  Environment
} from "appRoot/app.constants";
import {BookingStatusTypes} from "app/bookingStatusTypes";

/**
 * Provides assets needed for the legacy angularJS constants, but doesn't actually attach it to a module.
 * This alllows it to be used for unit tests as well.
 */

interface IMapPair {
  name: string;
  value: any;
}

export const legacyConstantMap: IMapPair[] = [
  {name: 'hardCodedTags', value: hardCodedTags},
  {name: 'BookingType', value: BookingType},
  {name: 'BookingStatusTypes', value: BookingStatusTypes},
  {name: 'StandbyCommunicationTypes', value: StandbyCommunicationTypes},
  {name: 'appURLS', value: appURLS},
  {name: 'appConstants', value: {
      Blockout: { RepeatTypes: BlockoutRepeatTypes},
      Payment: { PaymentTypes },
      DocumentTypes, BookingStatus, Providers, AppCache, Database, ViewTypes, Dimensions,
      Environment
    }},
];
